<template>
    <div >
        <div v-for="items in MatterGroupMap">
            <div class="matters-box">
                <p class="title-line">{{items.title}}</p>
                <ul>
                    <router-link tag="li" to="" @click.native="insertJump(item.pcc,item.guid,item.alt)" v-for="(item,index) in items.list" :key="index">
                        <img :src="item.src" :alt="item.alt">
                        <p>{{item.alt}}</p>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {MatterGroupMap} from "./matterCen/matterCenter"
    import { Dialog } from 'vant'
  export default {
      components: {
          [Dialog.name]: Dialog
      },
    data() {
      return {
          MatterGroupMap:MatterGroupMap
      }
    },
      mounted(){
      },
      methods:{
          insertJump(pcc,guid,alt) {
              // 点击进入事项列表添加标识
                  window.sessionStorage.setItem('matterJump', 'Y')
                  this.$router.push({path:"/matterListByGroup",query:{pcc:pcc,guid:guid,alt:alt}})
          }
      }
  }
</script>

<style lang="less" scoped>
    .matters-box {
        padding: .33rem .24rem 0;
        background: #fff;
        border-bottom: .11rem solid #f4f6f8;

        .title-line {
            position: relative;
            padding-left: .2rem;
            margin-bottom: .36rem;
            font-weight: 500;
            font-size: .32rem;
            color: #222;
        }

        .title-line:before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: .06rem;
            height: 80%;
            background: #1349DD;

        }

        ul {
            display: flex;
            flex-wrap: wrap;
            padding: 0 .35rem;

            li {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 1.65rem;
                margin: 0 .7rem .35rem 0;
                text-align: center;

                img {
                    width: 1.3rem;
                    height: 1.3rem;
                }

                p {
                    font-size: .28rem;
                    color: #222;
                }
            }

            li:nth-of-type(4n) {
                margin-right: 0;
            }
        }
    }
</style>
